import httpClient from '@yola/http-client';
import urlJoin from 'url-join';
import { connectedStore } from '../../store';
import config from '../../config';

const fetchWsAsset = (path) => {
  const store = connectedStore.get();
  const state = store.getState();
  const apiUrl = config.selectors.getServiceAPIUrl(state);
  const url = urlJoin(apiUrl, 'cdn', path);
  return httpClient.get(url);
};

export default fetchWsAsset;
